import { usePermissions } from "@/modules/auth/composables/usePermissions";

/**
 * Директива для управления видимостью элементов на основе прав доступа
 *
 * Использование:
 * v-access="'counterparties:create'" - проверка одного права
 * v-access="['counterparties:create', 'counterparties:edit']" - проверка любого из прав
 *
 * @example
 * <button v-access="'counterparties:create'">Создать</button>
 * <div v-access="['users:view', 'users:edit']">Контент</div>
 */
const applyAccess = (el, value) => {
  const { hasAccess } = usePermissions();

  if (!hasAccess(value)) {
    el.style.display = "none";
  } else {
    // Восстанавливаем исходный inline-display, а не затираем его пустой строкой.
    el.style.display = el._accessOriginalDisplay ?? "";
  }
};

export default {
  mounted(el, binding) {
    // Запоминаем исходный inline-display ДО возможного скрытия.
    el._accessOriginalDisplay = el.style.display === "none" ? "" : el.style.display;
    applyAccess(el, binding.value);
  },

  updated(el, binding) {
    applyAccess(el, binding.value);
  },
};
